// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   LinearProgress,
//   TextField,
//   Typography,
//   Box,
// } from "@material-ui/core";
// import "./Userform.css";
// import { getFirestore, doc, getDoc, setDoc, collection, addDoc } from "firebase/firestore"; //
// import { app } from "../firebase";
// import { useParams } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import share from "../images/share-alt-solid-24.png";
// import Popup from "./Popup";
// import SnackBar from "./SnackBar";
// import QRCode from "react-qr-code";
// import AlertDialog from './AlertDialog.js';
// import { getUserLocation } from './userLocation';

// function Userform({ value, capturedPhoto }) {
//   const { id } = useParams();
//   const [open, setOpen] = useState(false);
//   const [text, setText] = useState("success");
//   const [color, setColor] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [isPopupOpen, setPopupOpen] = useState(false);
//   const [formInfo, setFormInfo] = useState({
//     formName: "",
//     formDescription: "",
//     questions: [],
//     activate: "true",
//     timerDuration: 0,
//   });
//   const [responses, setResponses] = useState([]);
//   const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//   const [timeLeft, setTimeLeft] = useState(0); //Initialize with 0
//   const [includeLocation, setIncludeLocation] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const capturedPhotoURL = location.state?.photoURL;

//   // Extract user info passed from InstructionPage (name, email, phone)
//   const userInfo = location.state?.userInfo || { userName: 'Anonymous', userEmail: '', userPhone: '' };

//   useEffect(() => {
//     const fetchData = async () => {
//       const db = getFirestore(app);
//       const formRef = doc(db, "forms", id);
//       try {
//         const docSnap = await getDoc(formRef);
//         if (docSnap.exists()) {
//           const data = docSnap.data();
          
//           // Process the form data
//           const processedData = {
//             ...data,
//             // Convert activate to boolean
//             activate: typeof data.activate === 'string' 
//               ? data.activate.toLowerCase() === 'true'
//               : Boolean(data.activate),
//             // Ensure questions array exists
//             questions: data.questions || [],
//             // Convert timer duration to number if exists
//             timerDuration: data.timerDuration ? Number(data.timerDuration) : 0,
//             // Ensure other boolean fields are correct
//             enableTimer: Boolean(data.enableTimer),
//             includeLocation: Boolean(data.includeLocation),
//             isAnonymous: Boolean(data.isAnonymous)
//           };
  
//           // Update form info
//           setFormInfo(processedData);
//           setLoading(false);
  
//           // Set timer if enabled
//           if (processedData.enableTimer && processedData.timerDuration) {
//             setTimeLeft(processedData.timerDuration * 60);
//           }
  
//           // Set location tracking
//           if (processedData.includeLocation !== undefined) {
//             setIncludeLocation(processedData.includeLocation);
//           }
//         } else {
//           console.error("Form not found");
//           setColor("error");
//           setText("Form not found");
//           setOpen(true);
//           setLoading(false);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setColor("error");
//         setText("Error loading form. Please try again.");
//         setOpen(true);
//         setLoading(false);
//       }
//     };
  
//     fetchData();
//   }, [id]);

//   //timer
//   useEffect(() => {
//     if (formInfo.enableTimer && timeLeft > 0) {
//       const interval = setInterval(() => {
//         setTimeLeft((prevTime) => {
//           if (prevTime <= 1) {
//             clearInterval(interval);
//             saveResponsesToFirebase();
//             // Trigger form submission here when time runs out
//             return 0;
//           }
//           return prevTime - 1;
//         });
//       }, 1000);

//       return () => clearInterval(interval);
//     }
//   }, [formInfo, timeLeft]);


//   const formatTime = () => {
//     const hours = Math.floor(timeLeft / 3600);
//     const minutes = Math.floor((timeLeft % 3600) / 60);
//     const seconds = timeLeft % 60;
//     return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
//   };

//   const handleInputChange = (event, questionIndex) => {
//     const { type, value, checked } = event.target;
//     setResponses(prevResponses => {
//         const newResponses = [...prevResponses];
//         if (type === 'checkbox') {
//             if (!Array.isArray(newResponses[questionIndex])) {
//                 newResponses[questionIndex] = [];
//             }
//             if (checked) {
//                 if (!newResponses[questionIndex].includes(value)) {
//                     newResponses[questionIndex].push(value);
//                 }
//             } else {
//                 newResponses[questionIndex] = newResponses[questionIndex].filter(v => v !== value);
//             }
//         } else {
//             newResponses[questionIndex] = value; // Ensure even empty strings are recorded
//         }
//         return newResponses;
//     });
// };

//   const handleNextQuestion = () => {
//     // Check if it's the last question
//     if (currentQuestionIndex === formInfo.questions.length - 1) {
//       // Handle submission when all questions are answered
//       if (!isSubmitting) {
//         saveResponsesToFirebase();
//       }
//     } else {
//       // Move to the next question
//       setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
//     }
//   };

//   const getInitials = (email) => {
//     const parts = email.split("@");
//     if (parts.length === 2) {
//       const [username, domain] = parts;
//       const usernameParts = username.split(".");
//       return usernameParts.map((part) => part).join("");
//     }
//     return "";
//   };

//   async function saveResponsesToFirebase() {
//     if (isSubmitting) {
//       console.log('Form submission already in progress, ignoring duplicate request');
//       return;
//     }
    
//     setIsSubmitting(true);
//     const db = getFirestore(app);
//     const responsesRef = collection(db, "responses", id, "responses");
//     const initials = getInitials(value);
  
//     let totalPoints = 0;
//     const scoreDetails = [];
  
//     try {
//       let userLocation = null;
  
//       if (includeLocation) {
//         try {
//           userLocation = await getUserLocation();
//         } catch (error) {
//           console.warn("Failed to get user location:", error);
//           // Continue without location if it fails
//         }
//       }
  
//       // Get photo data from localStorage, but don't require it
//       const photoDownloadURL = localStorage.getItem('capturedPhotoURL') || null;
//       const photoData = localStorage.getItem('capturedPhotoData') || null;
//       const photoId = localStorage.getItem('capturedPhotoId') || null;
      
//       const formData = {
//         email: value || userInfo.userEmail || '',
//         userId: userInfo.userName !== 'Anonymous' ? userInfo.userName : (value || 'Anonymous'),
//         userName: userInfo.userName || 'Anonymous',
//         userEmail: userInfo.userEmail || value || '',
//         userPhone: userInfo.userPhone || '',
//         responses: [],
//         ques: formInfo.questions,
//         location: userLocation,
//         timestamp: new Date(),
//         totalPoints: 0,
//         isAnonymous: formInfo.isAnonymous || false,
//       };
  
//       // Only add photo data if it exists
//       if (photoDownloadURL && photoData) {
//         formData.photoDownloadURL = photoDownloadURL;
//         formData.photoData = photoData;
//         formData.photoId = photoId;
        
//         // Clean up localStorage after using
//         localStorage.removeItem('capturedPhotoURL');
//         localStorage.removeItem('capturedPhotoData');
//         localStorage.removeItem('capturedPhotoId');
//         localStorage.removeItem('capturedPhotoTimestamp');
//       }
  
//       for (let i = 0; i < formInfo.questions.length; i++) {
//         const question = formInfo.questions[i];
//         const userResponse = responses[i] || ''; // Default to empty string if undefined
//         let questionPoints = 0;
  
//         const responseData = {
//           question: question.questionText,
//           answer: userResponse,
//           answerKey: question.answerKey || [],
//         };
  
//         const points = Number(question.points) || 0;
//         if (question.questionType === 'checkbox') {
//           if (Array.isArray(userResponse) && Array.isArray(question.answerKey) && question.answerKey.length > 0) {
//             const correctAnswers = userResponse.filter(answer => question.answerKey.includes(answer));
//             const incorrectAnswers = userResponse.filter(answer => !question.answerKey.includes(answer));
//             const score = (correctAnswers.length / question.answerKey.length) - (incorrectAnswers.length / question.answerKey.length);
//             questionPoints = Math.max(0, score * points);
//           }
//         } else if (question.questionType === 'radio') {
//           if (userResponse === question.answerKey) {
//             questionPoints = points;
//           }
//         } else if (question.questionType === 'text') {
//           const expectedAnswer = typeof question.answerKey === "string" ? question.answerKey.trim() : "";
//           if (expectedAnswer && userResponse.trim().toLowerCase() === expectedAnswer.toLowerCase()) {
//             questionPoints = points;
//           }
//         }
  
//         totalPoints += questionPoints;
//         scoreDetails.push({ question: question.questionText, points: questionPoints });
  
//         formData.responses.push(responseData);
//       }
  
//       formData.totalPoints = totalPoints;
//       formData.scoreDetails = scoreDetails;
  
//       // Add some debugging
//       console.log('Submitting form data:', formData);
//       console.log('Responses collection path:', `responses/${id}/responses`);
  
//       await addDoc(responsesRef, formData);
  
//       setColor("success");
//       setText("Form is submitted Successfully");
//       setOpen(true);
//       await new Promise((resolve) => setTimeout(resolve, 2000));
  
//       navigate(`/form/${id}/thankyou`);
//     } catch (error) {
//       console.error("Error saving form data or getting location:", error);
//       console.error("Error details:", {
//         code: error.code,
//         message: error.message,
//         stack: error.stack
//       });
      
//                            // Check if it's a permission error and try alternative approach
//         if (error.code === 'permission-denied' || error.message.includes('PERMISSION_DENIED')) {
//           console.log('Permission denied, trying alternative submission method...');
          
//           // Try saving to a different collection or with different structure
//           try {
//             const alternativeRef = collection(db, "form_responses");
            
//             // Get photo data from localStorage again for alternative submission
//             const altPhotoDownloadURL = localStorage.getItem('capturedPhotoURL') || null;
//             const altPhotoData = localStorage.getItem('capturedPhotoData') || null;
//             const altPhotoId = localStorage.getItem('capturedPhotoId') || null;
            
//                          // Get user location again for alternative submission
//              let altUserLocation = null;
//              if (includeLocation) {
//                try {
//                  altUserLocation = await getUserLocation();
//                } catch (error) {
//                  console.warn("Failed to get user location for alternative submission:", error);
//                }
//              }
             
//              // Recreate the form data for alternative submission
//              const alternativeData = {
//                email: value,
//                responses: [],
//                ques: formInfo.questions,
//                location: altUserLocation,
//                timestamp: new Date(),
//                totalPoints: totalPoints,
//                scoreDetails: scoreDetails,
//                isAnonymous: formInfo.isAnonymous || false,
//                formId: id,
//                submittedAt: new Date(),
//                status: 'submitted'
//              };
            
//             // Add photo data if it exists
//             if (altPhotoDownloadURL && altPhotoData) {
//               alternativeData.photoDownloadURL = altPhotoDownloadURL;
//               alternativeData.photoData = altPhotoData;
//               alternativeData.photoId = altPhotoId;
//             }
            
//             // Add responses
//             for (let i = 0; i < formInfo.questions.length; i++) {
//               const question = formInfo.questions[i];
//               const userResponse = responses[i] || '';
              
//               const responseData = {
//                 question: question.questionText,
//                 answer: userResponse,
//                 answerKey: question.answerKey || [],
//               };
              
//               alternativeData.responses.push(responseData);
//             }
            
//             await addDoc(alternativeRef, alternativeData);
            
//             // Clean up localStorage after successful alternative submission
//             localStorage.removeItem('capturedPhotoURL');
//             localStorage.removeItem('capturedPhotoData');
//             localStorage.removeItem('capturedPhotoId');
//             localStorage.removeItem('capturedPhotoTimestamp');
            
//             setColor("success");
//             setText("Form is submitted Successfully");
//             setOpen(true);
//             await new Promise((resolve) => setTimeout(resolve, 2000));
            
//             navigate(`/form/${id}/thankyou`);
//             return;
//           } catch (altError) {
//             console.error("Alternative submission also failed:", altError);
//           }
//         }
      
//       setColor("error");
//       setText("Error submitting form. Please try again.");
//       setOpen(true);
//     } finally {
//       setIsSubmitting(false);
//     }
//   }

//   const togglePopup = () => {
//     setPopupOpen(!isPopupOpen);
//   };

//   const handlePopup = () => {
//     togglePopup();
//   };

//   const handleCopy = () => {
//     const textField = document.createElement("textarea");
//     textField.innerText = url;
//     document.body.appendChild(textField);
//     textField.select();
//     document.execCommand("copy");
//     document.body.removeChild(textField);
//     setOpen(true);
//   };

//   const url = window.location.href;

//   const handleDownload = () => {
//     const qrCodeSVG = document.getElementById("123456"); // Replace with your SVG ID
//     const svgData = new XMLSerializer().serializeToString(qrCodeSVG);

//     const img = new Image();
//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = img.width;
//       canvas.height = img.height;

//       const ctx = canvas.getContext("2d");
//       ctx.drawImage(img, 0, 0);

//       const pngUrl = canvas.toDataURL("image/png");
//       const link = document.createElement("a");
//       link.href = pngUrl;
//       link.download = "qr_code.png";
//       link.click();
//     };
//     img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgData);
//   };

//   return (
//     <>
//       <div>
//         <SnackBar
//           open={open}
//           handleClose={() => setOpen(false)}
//           text={text}
//           color={color}
//         />
//         {formInfo.enableTimer && timeLeft > 0 && (
//           <Typography variant="h5" align="right"  style={{ marginRight: '30px' }}>Time Left: {formatTime()}</Typography>
//         )}
//         {loading ? (
//           <LinearProgress />
//         ) : formInfo.activate === true ? (
//           <>
//             <div className="container">
//               {/* Content inside the Popup */}
//               {/* <h2>Please share the form!</h2>
//               <p>
//                 {" "}
//                 <a href="" target="_blank">
//                   {window.location.href}
//                 </a>
//               </p> */}
//               {/* <div
//                 className="qr-code-container"
//                 id="qr-code-container"
//                 style={{
//                   height: "auto",
//                   margin: "0 auto",
//                   maxWidth: 64,
//                   width: "100%",
//                 }}
//               >
//                 <QRCode
//                   id="123456"
//                   size={256}
//                   style={{
//                     height: "auto",
//                     maxWidth: "100%",
//                     width: "100%",
//                   }}
//                   value={window.location.href}
//                   viewBox={`0 0 256 256`}
//                 />
//               </div> */}
//               {/* <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleDownload}
//               >
//                 {" "}
//                 Download QR {" "}
//               </Button> */}
//             </div>
//             <div className="submit">
//               <div className="user_form">
//                 <div className="user_form_section">
//                   <div className="user_title_section">
//                     <Typography style={{ fontSize: "26px" }}>
//                       {formInfo.formName}
//                     </Typography>
//                     <Typography style={{ fontSize: "15px" }}>
//                       {formInfo.formDescription}
//                     </Typography>
//                   </div>
//                   <br></br>
//                   <br></br>
//                   <Box>
//                   {Array.from({ length: formInfo.questions.length  }).map((_, index) => (
//                     <Button
//                       key={index}
//                       variant="contained"
//                       onClick={() => setCurrentQuestionIndex(index)}
//                       style={{ 
//                         marginRight: '10px', 
//                         marginBottom: '10px',
//                         color: 'white', // Text color
//                         backgroundColor: 
//                           responses[index] !== undefined ? "blue" : "grey", // Change color based on whether question is answered
//                       }}
//                     >
//                       {index + 1}
//                     </Button>
//                   ))}
//                 </Box>
//                   <br></br>
//                   <br></br>
//                   <div className="user_form_questions">
//                     <Typography
//                       style={{
//                         fontSize: "15px",
//                         fontWeight: "400",
//                         letterSpacing: ".1px",
//                         lineHeight: "24px",
//                         paddingBottom: "8px",
//                       }}
//                     >
//                       {currentQuestionIndex + 1}.{" "}
//                       {formInfo.questions[currentQuestionIndex].questionText}
//                     </Typography>

//                     {formInfo.questions[currentQuestionIndex].questionType === "text" ? (
//                       <TextField
//                         fullWidth
//                         type="text"
//                         name={`question-${currentQuestionIndex}`}
//                         label="Your answer"
//                         required={formInfo.questions[currentQuestionIndex].required}
//                         onChange={(event) => handleInputChange(event, currentQuestionIndex)}
//                         value={responses[currentQuestionIndex] || ""}
//                         variant="outlined"
//                       />
//                     ) : formInfo.questions[currentQuestionIndex].options.map(
//                       (option, optionIndex) => (
//                         <div key={optionIndex} style={{ marginBottom: "5px" }}>
//                           <div style={{ display: "flex" }}>
//                             <div className="form-check">
//                               {formInfo.questions[currentQuestionIndex].questionType === "checkbox" ? (
//                                 <label>
//                                   <input
//                                     type="checkbox"
//                                     name={`${currentQuestionIndex}[]`}
//                                     value={option.optionText}
//                                     className="form-check-input"
//                                     required={formInfo.questions[currentQuestionIndex].required}
//                                     onChange={(event) => handleInputChange(event, currentQuestionIndex)}
//                                     checked={responses[currentQuestionIndex]?.includes(option.optionText)}
//                                     style={{
//                                       marginLeft: "5px",
//                                       marginRight: "5px",
//                                     }}
//                                   />
//                                   {option.optionText}
//                                 </label>
//                               ) : (
//                                 <label>
//                                   <input
//                                     type="radio"
//                                     name={currentQuestionIndex}
//                                     value={option.optionText}
//                                     className="form-check-input"
//                                     required={formInfo.questions[currentQuestionIndex].required}
//                                     onChange={(event) => handleInputChange(event, currentQuestionIndex)}
//                                     checked={responses[currentQuestionIndex] === option.optionText}
//                                     style={{
//                                       marginLeft: "5px",
//                                       marginRight: "5px",
//                                     }}
//                                   />
//                                   {option.optionText}
//                                 </label>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       )
//                     )}
//                   </div>
//                   <div className="user_form_submit">
//                   <br></br>
//                   <br></br>
//                                      <Button
//                        variant="contained"
//                        color="primary"
//                        disabled={isSubmitting}
//                        style={{
//                          fontSize: "14px",
//                          color: "white",
//                          backgroundColor: isSubmitting ? "#cccccc" : "#236AE7",
//                        }}
//                        onClick={handleNextQuestion}
//                      >
//                        {currentQuestionIndex === formInfo.questions.length - 1
//                          ? (isSubmitting ? "Submitting..." : "Submit")
//                          : "Next Question"}
//                      </Button>
//                   </div>
//                   <br></br>
//                   <br></br>
//                   <br></br>
//                   <br></br>
//                   <br></br>
//                   <br></br>
//                   <div className="user_footer"><strong>SUREWAY</strong><small>by OmneVu.com</small></div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <>
//             <div className="submit">
//               <div className="user_form">
//                 <div className="user_form_section">
//                   <div className="user_title_section">
//                     <Typography style={{ fontSize: "22px" }}>
//                       This survey has stopped accepting any new responses. Please
//                       contact the administrator.
//                     </Typography>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// }

// export default Userform;

import React, { useEffect, useState } from "react";
import {
  Button,
  LinearProgress,
  TextField,
  Typography,
  Box,
} from "@material-ui/core";
import "./Userform.css";
import {
  getFirestore,
  doc,
  getDoc,
  collection,
  addDoc,
} from "firebase/firestore";
import { app } from "../firebase";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import SnackBar from "./SnackBar";
import { getUserLocation } from "./userLocation";
import { gradeSubmission } from "./grading";

function Userform({ value, capturedPhoto }) {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("success");
  const [color, setColor] = useState("");
  const [loading, setLoading] = useState(true);
  const [formInfo, setFormInfo] = useState({
    formName: "",
    formDescription: "",
    questions: [],
    activate: "true",
    timerDuration: 0,
  });
  const [responses, setResponses] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [includeLocation, setIncludeLocation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationError, setValidationError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Extract user info passed from InstructionPage (name, email, phone)
  const userInfo = location.state?.userInfo || {
    userName: "Anonymous",
    userEmail: "",
    userPhone: "",
  };

  useEffect(() => {
    const fetchData = async () => {
      const db = getFirestore(app);
      const formRef = doc(db, "forms", id);
      try {
        const docSnap = await getDoc(formRef);
        if (docSnap.exists()) {
          const data = docSnap.data();

          const processedData = {
            ...data,
            activate:
              typeof data.activate === "string"
                ? data.activate.toLowerCase() === "true"
                : Boolean(data.activate),
            questions: data.questions || [],
            timerDuration: data.timerDuration
              ? Number(data.timerDuration)
              : 0,
            enableTimer: Boolean(data.enableTimer),
            includeLocation: Boolean(data.includeLocation),
            isAnonymous: Boolean(data.isAnonymous),
          };

          setFormInfo(processedData);

          if (processedData.enableTimer && processedData.timerDuration) {
            setTimeLeft(processedData.timerDuration * 60);
          }

          setLoading(false);

          if (processedData.includeLocation !== undefined) {
            setIncludeLocation(processedData.includeLocation);
          }
        } else {
          console.error("Form not found");
          setColor("error");
          setText("Form not found");
          setOpen(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setColor("error");
        setText("Error loading form. Please try again.");
        setOpen(true);
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // timer
  useEffect(() => {
    if (formInfo.enableTimer && timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval);
            if (formInfo.questions && formInfo.questions.length > 0) {
              saveResponsesToFirebase();
            }
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formInfo, timeLeft]);

  const formatTime = () => {
    const hours = Math.floor(timeLeft / 3600);
    const minutes = Math.floor((timeLeft % 3600) / 60);
    const seconds = timeLeft % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleInputChange = (event, questionIndex) => {
    const { type, value, checked } = event.target;
    setValidationError("");
    setResponses((prevResponses) => {
      const newResponses = [...prevResponses];
      if (type === "checkbox") {
        if (!Array.isArray(newResponses[questionIndex])) {
          newResponses[questionIndex] = [];
        }
        if (checked) {
          if (!newResponses[questionIndex].includes(value)) {
            newResponses[questionIndex].push(value);
          }
        } else {
          newResponses[questionIndex] = newResponses[questionIndex].filter(
            (v) => v !== value
          );
        }
      } else {
        newResponses[questionIndex] = value;
      }
      return newResponses;
    });
  };

  // A required question is considered "answered" only if it actually has
  // content — an empty string, empty array, or undefined all count as
  // unanswered. Native HTML `required` never fires here because the inputs
  // aren't inside a <form>, so this check is what actually enforces it.
  const isCurrentQuestionAnswered = () => {
    const question = formInfo.questions[currentQuestionIndex];
    if (!question || !question.required) return true;

    const answer = responses[currentQuestionIndex];
    if (Array.isArray(answer)) return answer.length > 0;
    return Boolean(answer && String(answer).trim() !== "");
  };

  const handleNextQuestion = () => {
    if (!isCurrentQuestionAnswered()) {
      setValidationError("This question is required — please answer it before continuing.");
      return;
    }
    setValidationError("");

    if (currentQuestionIndex === formInfo.questions.length - 1) {
      if (!isSubmitting) {
        saveResponsesToFirebase();
      }
    } else {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handlePreviousQuestion = () => {
    setValidationError("");
    setCurrentQuestionIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };

  const getInitials = (email) => {
    const parts = email.split("@");
    if (parts.length === 2) {
      const [username] = parts;
      const usernameParts = username.split(".");
      return usernameParts.map((part) => part).join("");
    }
    return "";
  };

  async function saveResponsesToFirebase() {
    if (isSubmitting) {
      console.log(
        "Form submission already in progress, ignoring duplicate request"
      );
      return;
    }

    if (!formInfo.questions || formInfo.questions.length === 0) {
      console.warn("No questions to submit.");
      return;
    }

    setIsSubmitting(true);
    const db = getFirestore(app);
    const responsesRef = collection(db, "responses", id, "responses");
    const candidateDetails = JSON.parse(
      sessionStorage.getItem("candidateDetails") || "{}"
    );
    const isAnonymousSubmission = !formInfo.requireName;
    const candidateEmail = isAnonymousSubmission
      ? ""
      : value || candidateDetails.email || userInfo.userEmail || "";
    const candidateName = isAnonymousSubmission
      ? "Anonymous"
      : candidateDetails.name || userInfo.userName || "Anonymous";
    getInitials(value);

    let totalPoints = 0;
    const scoreDetails = [];

    try {
      let userLocation = null;

      if (includeLocation) {
        try {
          userLocation = await getUserLocation();
        } catch (error) {
          console.warn("Failed to get user location:", error);
        }
      }

      const photoDownloadURL =
        localStorage.getItem("capturedPhotoURL") || null;
      const photoData = localStorage.getItem("capturedPhotoData") || null;
      const photoId = localStorage.getItem("capturedPhotoId") || null;

      const formData = {
        email: candidateEmail,
        userId:
          candidateName !== "Anonymous" ? candidateName : "Anonymous",
        userName: candidateName,
        userEmail: candidateEmail,
        userPhone: isAnonymousSubmission ? "" : candidateDetails.phone || userInfo.userPhone || "",
        responses: [],
        ques: formInfo.questions,
        location: userLocation,
        timestamp: new Date(),
        totalPoints: 0,
        isAnonymous: isAnonymousSubmission,
      };

      if (photoDownloadURL && photoData) {
        formData.photoDownloadURL = photoDownloadURL;
        formData.photoData = photoData;
        formData.photoId = photoId;

        localStorage.removeItem("capturedPhotoURL");
        localStorage.removeItem("capturedPhotoData");
        localStorage.removeItem("capturedPhotoId");
        localStorage.removeItem("capturedPhotoTimestamp");
      }

// ==========================================================================
// GRADE VIA THE SHARED GRADER (see src/grading.js)
//
// Using the same gradeSubmission() function that the results page uses to
// re-check a submission guarantees the two can never disagree — this is
// what fixes "correct answer selected but shown/scored as wrong": that bug
// came from two separate, subtly different scoring implementations that
// could go out of sync (especially when a question's answerKey ended up
// the wrong shape, e.g. [] for a radio question).
// ==========================================================================
const { totalPoints, scoreDetails } = gradeSubmission(
  formInfo.questions,
  responses
);

formInfo.questions.forEach((question, i) => {
  formData.responses.push({
    question: question.questionText,
    answer: responses[i] ?? "",
    answerKey: question.answerKey ?? "",
  });
});

formData.totalPoints = totalPoints;
formData.scoreDetails = scoreDetails;

      const submittedDocRef = await addDoc(responsesRef, formData);

      // Record exactly which response document belongs to this candidate so
      // the Thank You page can fetch and grade this specific submission
      // instead of guessing at "whichever one was submitted most recently".
      sessionStorage.setItem("lastResponseId", submittedDocRef.id);

      setColor("success");
      setText("Form is submitted Successfully");
      setOpen(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));

      navigate(`/form/${id}/thankyou`);
    } catch (error) {
      console.error("Error saving form data or getting location:", error);
      console.error("Error details:", {
        code: error.code,
        message: error.message,
        stack: error.stack,
      });

      if (
        error.code === "permission-denied" ||
        error.message.includes("PERMISSION_DENIED")
      ) {
        console.log(
          "Permission denied, trying alternative submission method..."
        );

        try {
          const alternativeRef = collection(db, "form_responses");

          const altPhotoDownloadURL =
            localStorage.getItem("capturedPhotoURL") || null;
          const altPhotoData = localStorage.getItem("capturedPhotoData") || null;
          const altPhotoId = localStorage.getItem("capturedPhotoId") || null;

          let altUserLocation = null;
          if (includeLocation) {
            try {
              altUserLocation = await getUserLocation();
            } catch (locError) {
              console.warn(
                "Failed to get user location for alternative submission:",
                locError
              );
            }
          }

          const alternativeData = {
            email: value,
            responses: [],
            ques: formInfo.questions,
            location: altUserLocation,
            timestamp: new Date(),
            totalPoints: totalPoints,
            scoreDetails: scoreDetails,
            isAnonymous: formInfo.isAnonymous || false,
            formId: id,
            submittedAt: new Date(),
            status: "submitted",
          };

          if (altPhotoDownloadURL && altPhotoData) {
            alternativeData.photoDownloadURL = altPhotoDownloadURL;
            alternativeData.photoData = altPhotoData;
            alternativeData.photoId = altPhotoId;
          }

          for (let i = 0; i < formInfo.questions.length; i++) {
            const question = formInfo.questions[i];
            const userResponse = responses[i] || "";

            alternativeData.responses.push({
              question: question.questionText,
              answer: userResponse,
              answerKey: question.answerKey || [],
            });
          }

          const altDocRef = await addDoc(alternativeRef, alternativeData);
          sessionStorage.setItem("lastResponseId", altDocRef.id);

          localStorage.removeItem("capturedPhotoURL");
          localStorage.removeItem("capturedPhotoData");
          localStorage.removeItem("capturedPhotoId");
          localStorage.removeItem("capturedPhotoTimestamp");

          setColor("success");
          setText("Form is submitted Successfully");
          setOpen(true);
          await new Promise((resolve) => setTimeout(resolve, 2000));

          navigate(`/form/${id}/thankyou`);
          return;
        } catch (altError) {
          console.error("Alternative submission also failed:", altError);
        }
      }

      setColor("error");
      setText("Error submitting form. Please try again.");
      setOpen(true);
    } finally {
      setIsSubmitting(false);
    }
  }

  const totalQuestions = formInfo.questions.length;
  const answeredCount = responses.filter((r) =>
    Array.isArray(r) ? r.length > 0 : Boolean(r && String(r).trim() !== "")
  ).length;
  const progressPercent =
    totalQuestions > 0 ? (answeredCount / totalQuestions) * 100 : 0;

  const currentQuestion = formInfo.questions[currentQuestionIndex];
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;

  return (
    <>
      <div className="userform-page">
        <SnackBar
          open={open}
          handleClose={() => setOpen(false)}
          text={text}
          color={color}
        />

        {loading ? (
          <LinearProgress />
        ) : formInfo.activate === true ? (
          totalQuestions === 0 ? (
            <div className="submit">
              <div className="user_form">
                <div className="user_form_section">
                  <div className="user_title_section">
                    <Typography style={{ fontSize: "20px" }}>
                      This test doesn't have any questions yet. Please check
                      back later.
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="submit">
              <div className="user_form">
                <div className="user_form_section">
                  {/* ============================================
                      TOP CARD — title, description, progress, timer
                  ============================================ */}
                  <div className="user_title_section">
                    <div className="uf-title-row">
                      <div>
                        <Typography className="uf-form-name">
                          {formInfo.formName}
                        </Typography>
                        <Typography className="uf-form-desc">
                          {formInfo.formDescription}
                        </Typography>
                      </div>

                      {formInfo.enableTimer && timeLeft > 0 && (
                        <div className="uf-timer-badge">
                          <span className="uf-timer-dot" />
                          {formatTime()}
                        </div>
                      )}
                    </div>

                    <div className="uf-progress-row">
                      <div className="uf-progress-track">
                        <div
                          className="uf-progress-fill"
                          style={{ width: `${progressPercent}%` }}
                        />
                      </div>
                      <span className="uf-progress-label">
                        {answeredCount}/{totalQuestions} answered
                      </span>
                    </div>
                  </div>

                  {/* ============================================
                      QUESTION NAVIGATOR PILLS
                  ============================================ */}
                  <div className="uf-nav-card">
                    <Box className="uf-pill-row">
                      {formInfo.questions.map((_, index) => {
                        const isAnswered = Array.isArray(responses[index])
                          ? responses[index].length > 0
                          : Boolean(
                              responses[index] &&
                                String(responses[index]).trim() !== ""
                            );
                        const isCurrent = index === currentQuestionIndex;

                        return (
                          <button
                            key={index}
                            type="button"
                            className={`uf-pill ${
                              isCurrent ? "uf-pill-current" : ""
                            } ${isAnswered ? "uf-pill-answered" : ""}`}
                            onClick={() => {
                              setValidationError("");
                              setCurrentQuestionIndex(index);
                            }}
                          >
                            {index + 1}
                          </button>
                        );
                      })}
                    </Box>
                  </div>

                  {/* ============================================
                      CURRENT QUESTION CARD
                  ============================================ */}
                  <div className="user_form_questions uf-question-card">
                    <div className="uf-question-header">
                      <span className="uf-question-index">
                        Question {currentQuestionIndex + 1} of{" "}
                        {totalQuestions}
                      </span>
                      {currentQuestion?.required && (
                        <span className="uf-required-chip">Required</span>
                      )}
                    </div>

                    <Typography className="uf-question-text">
                      {currentQuestion?.questionText}
                    </Typography>

                    {currentQuestion?.questionType === "text" ? (
                      <TextField
                        fullWidth
                        type="text"
                        name={`question-${currentQuestionIndex}`}
                        label="Your answer"
                        onChange={(event) =>
                          handleInputChange(event, currentQuestionIndex)
                        }
                        value={responses[currentQuestionIndex] || ""}
                        variant="outlined"
                        className="uf-text-input"
                      />
                    ) : (
                      <div className="uf-options-list">
                        {(currentQuestion?.options || []).map(
                          (option, optionIndex) => {
                            const isChecked =
                              currentQuestion.questionType === "checkbox"
                                ? Boolean(
                                    responses[currentQuestionIndex]?.includes(
                                      option.optionText
                                    )
                                  )
                                : responses[currentQuestionIndex] ===
                                  option.optionText;

                            return (
                              <label
                                key={optionIndex}
                                className={`uf-option-row ${
                                  isChecked ? "uf-option-row-selected" : ""
                                }`}
                              >
                                <input
                                  type={
                                    currentQuestion.questionType === "checkbox"
                                      ? "checkbox"
                                      : "radio"
                                  }
                                  name={
                                    currentQuestion.questionType === "checkbox"
                                      ? `${currentQuestionIndex}[]`
                                      : `${currentQuestionIndex}`
                                  }
                                  value={option.optionText}
                                  className="uf-option-input"
                                  onChange={(event) =>
                                    handleInputChange(
                                      event,
                                      currentQuestionIndex
                                    )
                                  }
                                  checked={isChecked}
                                />
                                <span className="uf-option-indicator" />
                                <span className="uf-option-text">
                                  {option.optionText}
                                </span>
                              </label>
                            );
                          }
                        )}
                      </div>
                    )}

                    {validationError && (
                      <div className="uf-validation-error">
                        {validationError}
                      </div>
                    )}
                  </div>

                  {/* ============================================
                      STICKY ACTION BAR
                  ============================================ */}
                  <div className="uf-action-bar">
                    <Button
                      variant="outlined"
                      className="uf-prev-button"
                      disabled={currentQuestionIndex === 0}
                      onClick={handlePreviousQuestion}
                    >
                      Previous
                    </Button>

                    <Button
                      variant="contained"
                      disabled={isSubmitting}
                      className="uf-next-button"
                      onClick={handleNextQuestion}
                    >
                      {isLastQuestion
                        ? isSubmitting
                          ? "Submitting..."
                          : "Submit"
                        : "Next Question"}
                    </Button>
                  </div>

                  <div className="user_footer">
                    <strong>SUREWAY</strong>
                    <small>by OmneVu.com</small>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className="submit">
            <div className="user_form">
              <div className="user_form_section">
                <div className="user_title_section">
                  <Typography style={{ fontSize: "22px" }}>
                    This survey has stopped accepting any new responses.
                    Please contact the administrator.
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Userform;